import {
	SNACKS_POST_CONTAINER_REQUEST,
	SNACKS_POST_CONTAINER_RESPONSE,
	SNACKS_POST_CONTAINER_ERROR,
	SNACKS_RESET_CONTAINER_STATE,
	SNACKS_POST_CONTAINER_CHECK,
} from '../constants/ActionTypes';

const initialState = {
	container: {},
	finish: false,
	loading: false,
	error: '',
	check: {
		repeated: false,
		message: '',
	},
};

const snacksWMS = (state = initialState, action) => {
	switch (action.type) {
		case SNACKS_POST_CONTAINER_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			};
		case SNACKS_POST_CONTAINER_RESPONSE:
			return {
				...state,
				container: action.payload.data.container || null,
				finish: true,
				loading: false,
			};
		case SNACKS_POST_CONTAINER_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload.error || 'Unknow error',
			};
		case SNACKS_POST_CONTAINER_CHECK:
			return {
				...state,
				check: {
					repeated: true,
					message: action.payload.data,
				},
			};
		case SNACKS_RESET_CONTAINER_STATE:
			return {
				container: {},
				finish: false,
				loading: false,
				error: '',
				check: {
					repeated: false,
					message: '',
				},
			};
		default:
			return state;
	}
};

export default snacksWMS;
